import { hubspotConfig } from '@api/auth/config';
import { useEffect } from 'react';

export function HubSpotTracker() {
  useEffect(() => {
    // 1. Check if the script is already there to prevent duplicates
    if (document.getElementById('hs-script-loader')) return;

    // 2. Create and inject the script
    const script = document.createElement('script');
    script.src = `//js.hs-scripts.com/${hubspotConfig.accountId}.js`;
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    // Note: We typically don't remove tracking scripts on unmount
    // because we want them to persist across the user's session.
    console.info('loading HubSpot scripts');
  }, []);

  // This component doesn't render any UI
  return null;
}
